import type { FaireProductEntity } from "../../entity_types/product";

export const p_cyqdnqvaga: FaireProductEntity = {
  token: "p_cyqdnqvaga",
  type: "product",
  name: "Macadamia Nuts - Sea Salt - 8oz",
  brandName: "Hawaiian Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/11c3282e46dab3e4b44199a0d5abee65e423e2e2271bf03ae36a6792888faa8d.jpeg",
  priceDollars: 8.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c665126c08e065f795a95eeaa5c538ef7ae31bd46bff34bce1b7ecda4131f082.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
